import React, { useEffect, useState } from 'react';
import { Node } from '../../autogenerated/ZoomBridge';
import { Button } from '../../common';
import ExpandButton from '../../common/ExpandButton';
import { TextWithEllipsisFileExtension } from '../../common/TextWithEllipsis';
import t from '../../i18n/I18n';
import { toast } from '../../store/StoreUtil';
import { ThemeSetup } from '../../themes/ThemeSetup';
import { BROWSE_EXT_CONSTANT } from '../../util/Constants';
import BrowseExtChild from './BrowseExtChild';
import './BrowseExtParent.css';
import { BrowseExtUtil } from './BrowseExtUtil';
import MorePopover from '../../common/context-menu/MorePopover';

type browseExtParentProps = {
  parent_key: string,
  bucketName: string,
  type: string,
  childNode: Node
};

export type extDetailsType = {
  bucketName: String,
  node: Node
};

function BrowseExtParent(props: browseExtParentProps) {
  const [show, setShow] = useState(false);
  const [coordinates, setCoordinates] = useState(false);
  const [node, setNode] = useState(new Node());
  const [loading, setLoading] = useState(false);
  const [childLoading, setChildLoading] = useState(false);
  useEffect(() => {
    if (props.parent_key === BROWSE_EXT_CONSTANT.KEYS.ROOT) {
      BrowseExtUtil.fetchRootNode(props.bucketName, props.parent_key, setNode, setLoading);
    }
  }, [props.bucketName]);

  useEffect(() => {
    if (props.childNode) {
      setNode(props.childNode);
    }
  }, [props.childNode]);

  useEffect(() => {
    if (loading) setLoading(false);

    if (BrowseExtUtil.isRootNodeKey(node.getKey())) setShow(true);
  }, [node]);

  const onExpandBtnClick = (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setShow(!show);
    if (BrowseExtUtil.isNoChilds(node))
      BrowseExtUtil.fetchRootNode(props.bucketName, node.getKey(), setNode, setLoading);
  };

  const onFileClick = (e: MouseEvent) => {
    e.stopPropagation();
  };

  const onContextMenu = (e: MouseEvent) => {
    e.preventDefault();
    if(props.bucketName && node.getKey()) {
      if (!BrowseExtUtil.isIngested(node.getStatus())) {
        setCoordinates({
          screenX: e.clientX,
          screenY: e.clientY
        });
      } else {
        toast(t('ALREADY_INGESTED'));
      }
    } else return;
   
  };

  const onCloseContextMenu = () => {
    setCoordinates(false);
  };

  const onRefresh = (value: extDetailsType) => {
    BrowseExtUtil.fetchRootNode(value.bucketName, value.node.getKey(), setNode, setLoading, true);
  };

  const concatNodeChilds = (newNode: Node) => {
    const newChilds = newNode.getChildNodes();
    const currentChilds = node.getChildNodes();
    const totalChilds = currentChilds.concat(newChilds);
    node.setChildNodes(totalChilds);
    node.setHasMoreObjects(newNode.isHasMoreObjects());
    setChildLoading(false);
  };

  const getContent = () => {
    const label = BrowseExtUtil.getLabel(node.getKey(), props.type);
    const isFolder = BrowseExtUtil.isFolder(props.type);
    const textStyle = {
      paddingLeft: 10,
      margin: 'unset',
      color: show && isFolder ? 'var(--primary-font-color-selected)' : 'var(--primary-font-color)'
    };
    const { bucketName, parent_key } = props;
    return (
      <React.Fragment>
        <div
          className="flex-row browse-parent-icon-container"
          onClick={isFolder ? onExpandBtnClick : onFileClick}
          onContextMenu={onContextMenu}>
          <ExpandButton
            isExpanded={show}
            // onClick={onExpandBtnClick}
            visibility={isFolder ? false : true}></ExpandButton>
          {loading ? (
            getLoader()
          ) : isFolder ? (
            <img src={BrowseExtUtil.getIcon(show)} className="folder-icon"></img>
          ) : (
            <img className="plane-file-icon" src={BrowseExtUtil.getFileIcon()}></img>
          )}
          {BrowseExtUtil.isIngested(node.getStatus()) ? (
            <img className="ingest-icon" src={BrowseExtUtil.getIngestIcon()}></img>
          ) : null}
          <TextWithEllipsisFileExtension title={label} text={label} style={textStyle}>
            <div className={show ? 'active' : 'not-active'}>{label}</div>
          </TextWithEllipsisFileExtension>
        </div>
        {show && !loading ? <BrowseExtChild node={node} bucketName={bucketName}></BrowseExtChild> : null}
        {node.isHasMoreObjects() && show ? (
          !childLoading ? (
            <Button
              icon="images/more.svg"
              style={{ marginLeft: 32, fontSize: 12 }}
              tooltipStyle={{ width: 16 }}
              imgCls="ext-more"
              labelClass="ext-more-label"
              title="Load more"
              onClick={() => {
                BrowseExtUtil.fetchRootNode(
                  bucketName,
                  parent_key,
                  concatNodeChilds,
                  setChildLoading,
                  false,
                  BrowseExtUtil.getLastChildNodeKey(node)
                );
              }}></Button>
          ) : (
            <div className="child-loader-container">{getLoader()}</div>
          )
        ) : null}
        <MorePopover
          closeContextMenu={onCloseContextMenu}
          showPopover={coordinates}
          onRefresh={onRefresh}
          extDetails={{ node: node, bucketName: bucketName }}></MorePopover>
      </React.Fragment>
    );
  };

  const getLoader = () => {
    return <img className="loading-spinner" src={ThemeSetup.getImageURL('RingSpinner.svg')}></img>;
  };

  return (
    <div name="BrowseExtParent" className="flex-col">
      {getContent()}
    </div>
  );
}

export default BrowseExtParent;
